import { gql } from 'apollo-boost';

const manyQuery = gql`
  query trainers($inputFilter: UserFilterInputObjectType) {
    trainers(inputFilter: $inputFilter) {
      id
      clubId
      firstName
      lastName
      middleName
      fullName
      fullInitials
      enFullName
      gender
      status
      types
      email
      permissions
      birthday
      category
      licenseTerm
      sections
      club {
        id
        shortName
      }
      photo {
        id
        url
      }
      gyms {
        id
        name
      }
    }
  }
`;

const oneQuery = gql`
  query trainer($id: Int!) {
    trainer(id: $id) {
      id
      clubId
      firstName
      lastName
      middleName
      fullName
      enFullName
      email
      gender
      status
      types
      permissions
      birthday
      category
      licenseTerm
      phone
      address
      sections
      club {
        id
        shortName
      }
      photo {
        id
        url
      }
    }
  }
`;

export const paginatedTrainersQuery = gql`
  query getPaginatedTrainers($inputFilter: TrainerFilterInputType) {
    paginatedTrainers(inputFilter: $inputFilter) {
      items {
        id
        clubId
        firstName
        lastName
        middleName
        fullName
        enFullName
        gender
        status
        types
        email
        permissions
        birthday
        category
        licenseTerm
        sections
        trainerStatus
        club {
          id
          shortName
        }
        photo {
          id
          url
        }
        gyms {
          id
          name
        }
      }
      pageInfo {
        total
        page
        pages
      }
    }
  }
`;

export const createMutation = gql`
  mutation createTrainer($inputData: TrainerInputType!) {
    createTrainer(inputData: $inputData) {
      ok
      errors {
        field
        messages
        code
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updateTrainer($id: Int!, $inputData: TrainerInputType!) {
    updateTrainer(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
        code
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteTrainer($id: Int!) {
    deleteTrainer(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const archivateMutation = gql`
  mutation archivateTrainer($id: Int!, $reason: String!) {
    archivateTrainer(id: $id, reason: $reason) {
      ok
      errors {
        field
        messages
        code
      }
    }
  }
`;

export const activateMutation = gql`
  mutation activateTrainer($id: Int!) {
    activateTrainer(id: $id) {
      ok
      errors {
        field
        messages
        code
      }
    }
  }
`;

const TRAINERS = {
  manyQuery,
  oneQuery,
  archivateMutation,
  activateMutation,
  createMutation,
  updateMutation,
  deleteMutation,
  paginatedTrainersQuery,
};

export default TRAINERS;
